import axios from 'axios';

/**
 * 后端API的基础URL。
 * 在实际部署中，这应该配置为服务器的实际地址。
 */
const API_BASE_URL = 'https://visitor.ascendsun.com/api'; // 后端API地址

/**
 * 访客日志接口定义。
 * 描述了访客日志对象的结构。
 */
export interface VisitorLog {
  id: number;
  ipAddress: string;
  timestamp: string;
  websiteId: string;
  location?: string;
}

/**
 * 每日网站统计接口定义。
 * 描述了每日网站统计对象的结构。
 */
export interface DailyWebsiteStats {
  websiteId: string;
  date: string; // LocalDate is handled as string in frontend
  count: number;
}

/**
 * 获取特定网站的访客日志列表。
 * @param websiteId 网站的唯一标识符。
 * @returns 访客日志数组的Promise。
 */
export const getVisitorLogs = async (websiteId: string): Promise<VisitorLog[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/visitorlogs/${websiteId}`);
        return response.data as VisitorLog[];
    } catch (error) {
        console.error("获取访客日志时出错:", error);
        throw error;
    }
};

/**
 * 获取特定网站的访客总数。
 * @param websiteId 网站的唯一标识符。
 * @returns 访客总数的Promise。
 */
export const getVisitorCount = async (websiteId: string): Promise<number> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/visitorlogs/${websiteId}/count`);
        return response.data as number;
    } catch (error) {
        console.error("获取访客总数时出错:", error);
        throw error;
    }
};

/**
 * 获取每日网站访问统计数据。
 * @returns 每日网站访问统计数组的Promise。
 */
export const getDailyWebsiteStats = async (): Promise<DailyWebsiteStats[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/visitorlogs/daily-stats`);
        return response.data as DailyWebsiteStats[];
    } catch (error) {
        console.error("获取每日网站统计数据时出错:", error);
        throw error;
    }
};